import '../Shared/translations.js';
import '../Shared/shared_constants.js.php';
import '../Shared/handlebars.js';
import '../Shared/shared_hbs_templates.js.php';
import '../Shared/global.js';
import '../Shared/PopupModal/index.js';
import '../Shared/Announcements/index.js';
